module.exports = __webpack_public_path__ + "static/media/luta_square.4b443b0b.png";